import React from "react"

// Components
import Banners from "./Banners"
// Hooks
import useResponsiveVisible from "../../hooks/useResponsiveVisible"

/**
 * @param type - the type of the banner items
 * @param country - the country of the user
 * */
const BannerSection = ({ type, country }) => {
  /*===========================================
    HANDLE BANNERS VISIBILITY
    - hide them on mobile
  =========================================*/
  const isResponsiveVisible = useResponsiveVisible()

  return (
    <section className="home-hero">
      {!isResponsiveVisible && country && <Banners type={type} country={country} />}
    </section>
  )
}
export default BannerSection
